module.exports = __webpack_public_path__ + "static/img/sample1.5255527.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sample1.jpeg
// module id = 5EPJ
// module chunks = 1